module.exports = __webpack_public_path__ + "img/jxsy3.457f9ff3.jpg";